import { Card, CardBody, Col } from "reactstrap";
import { Badges, Image } from "../../../AbstractElements";
import { ImageWithCloseBadgesTitle } from "../../../Constants/Constants";
import { ImageBadgesData, ImageWithCloseBadgesSubTitle } from "../../../Data/UiKits/Tag&Pills";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { XCircle } from "react-feather";
import { dynamicImage } from "../../../Utils";

const ImageWithCloseBadges = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={ImageWithCloseBadgesTitle} span={ImageWithCloseBadgesSubTitle} />
        <CardBody>
          <div className="badge-spacing image-badges">
            {ImageBadgesData.map((item, index) => (
              <Badges pill color="" className={`"common-align txt-${item.color === "light" ? "dark" : item.color} badge-l-${item.color} border border-${item.color}`} key={index}>
                <Image className="rounded-circle me-1" src={dynamicImage(`dashboard/${item.image}`)} alt="user" />
                {item.color}<span className="vr mx-2"></span>
                <XCircle className={`ms-1 stroke-${item.color === "light" ? "dark" : item.color}`} />
              </Badges>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ImageWithCloseBadges;
